import "./CreateParcelAccount.scss";

import CreateParcelAccountAddressForm from "./components/CreateParcelAccountAddressForm";
import CreateParcelAccountVerificationForm from "./components/CreateParcelAccountVerificationForm";
import CreateParcelAccountHeader from "./components/CreateParcelAccountHeader";
import { CreateParcelAccountProvider, useCreateParcelAccountContext } from "./CreateParcelAccountState";

function CreateParcelAccountContent() {
  const { state } = useCreateParcelAccountContext();

  return (
    <div className="create-parcel-account">
      <CreateParcelAccountHeader />
      <div className="create-parcel-account__body">
        {!state.addressValidationResponse ? <CreateParcelAccountAddressForm /> : <CreateParcelAccountVerificationForm />}
      </div>
    </div>
  );
}

function CreateParcelAccount() {
  return (
    <CreateParcelAccountProvider>
      <CreateParcelAccountContent />
    </CreateParcelAccountProvider>
  );
}

export default CreateParcelAccount;
